import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { axiosBuzzOne } from '../../../../axios';
import { AUTH_TOKEN } from '../../../../environments';
import {
  getDiscoverAppUserPanelRoute,
  getDiscoveryUserRoute,
} from '../../utils/apiRoutes';
import { moduleName } from '../../moduleInfo';

export const getDiscoverAppUserPanelAsync = createAsyncThunk(
  `${moduleName}/getDiscoverAppUserPanelAsync`,
  async (payload) => {
    const { sortBY } = payload;
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getDiscoverAppUserPanelRoute(),
      headers: {
        Authorization: AUTH_TOKEN,
      },
      params: {
        sortBY,
      },
    });
    const data = response.data;
    return data;
  }
);

export const getDiscoveryUsersAsync = createAsyncThunk(
  `${moduleName}/getDiscoveryUsersAsync`,
  async (payload) => {
    const response = await axios({
      method: 'GET',
      url: getDiscoveryUserRoute(),
      headers: {
        Authorization: AUTH_TOKEN,
      },
      params: {
        ...payload,
      },
    });
    const data = response.data;
    return data;
  }
);

const dashboardDiscoverAppSlice = createSlice({
  name: `${moduleName}/dashboard`,
  initialState: {
    loading: false,
    discoverUserPanel: null,
    discoverUsersData: null,
  },
  reducers: {},
  extraReducers: {
    [getDiscoverAppUserPanelAsync.pending]: (state) => {
      state.loading = true;
    },
    [getDiscoverAppUserPanelAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.discoverUserPanel = action.payload.data;
    },
    [getDiscoverAppUserPanelAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getDiscoveryUsersAsync.pending]: (state) => {
      state.loading = true;
    },
    [getDiscoveryUsersAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.discoverUsersData = action.payload.data;
    },
    [getDiscoveryUsersAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default dashboardDiscoverAppSlice.reducer;
